import '../../resources/css/settings/RoleAuthList.scss';
import 'react-tabulator/lib/styles.css'; 
import "react-tabulator/lib/css/bootstrap/tabulator_bootstrap4.min.css";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ReactTabulator, reactFormatter } from 'react-tabulator';

let componentProps = null;

const selectAuthLevel = (cell, event) => {
  if (!componentProps.isReadonly) {
    cell.setValue(parseInt(event.target.value));
  }
}

const LevelSelector = (props, e) => {
  const cellRef = props.cell._cell;
  const value = "" + props.cell._cell.value;

  return (
    <div className='area-auth-level-selector'>
      <select className="auth-level-selector" onChange={(event) => selectAuthLevel(cellRef, event)} value={value}>
        <option value="0">No Allow</option>
        <option value="1">Readonly</option>
        <option value="2">Editor</option>
      </select>
    </div>
  );
}

class RoleAuthList extends Component {

  constructor(props) {
    super(props);

    componentProps = props;
  }
  
  /**
   *  reactFormatter bug, GroupBtnsMenu -> need before than reactFormatter
   *  
   ***/
  columns = [
    { title: "Seq", field: "seq", width: 100, visible: false },
    { title: "Table Name", field: "tableName" },
    { title: "Auth Level", field: "authLevel", formatter: reactFormatter(<LevelSelector />) , width: 200}
  ];

  componentDidUpdate(prevProps, prevState, snapshot){
    if(prevProps.isReadonly !== this.props.isReadonly){
      componentProps = this.props;
    }
  }

  render() {
    const { roleDetail } = this.props;
    const options = {
      movableRows: false
    };
    
    let tableContents = (<div className='pure-table'></div>)
    if (roleDetail && roleDetail.auth) {
      let filterData;
      if (window.CONFIG.VISUAL_DISPLAY) {
        filterData = roleDetail.auth;
      } else {
        filterData = [];
        roleDetail.auth.forEach((auth, index, array) => {
          if ("rf_map" !== auth.tableType) {
            filterData.push(auth);
          }
        });
      }

      tableContents =  (
        <ReactTabulator
          ref={ref => (this.ref = ref)}
          columns={this.columns}
          data={filterData}
          options={options}
          data-custom-attr="test-custom-attribute"
          className="custom-list-table"
        />
      );
    }

    return (
      <div className='role-auth-list'>
        <div className='custom-list-table-area'>
          { tableContents }
        </div>
      </div>
    )
  };
}

const mapStateToProps = (state, ownProps) => {
  const modalMessage = state.commonReducers.modalMessage;
  const isReadonly = modalMessage === 'view';

  return {
    roleDetail: state.settingsReducers.roleDetail,
    isReadonly: isReadonly
  }
}

export default withRouter(connect(
  mapStateToProps, 
  { }
)(RoleAuthList))
